<template lang="pug">
	.v-field-select.field-select
		label.field-select__label(v-if="field.label" :for="uniqueId")
			| {{field.label}}
			span.field-text__star(v-if="field.required") *
		button.field-select__btn(type="button"
			@click="openSelect"
			:id="uniqueId"
			:disabled="field.disabled")
			span.field-select__btn-text(v-if="localValue && localValue.length" key="text") {{ computedText || field.value.text }}
			span.field-select__btn-placeholder(v-else="" key="placeholder") {{field.placeholder}}
			v-svg-icon.field-select__btn-arrow(:icon="'chevron-down-sm'")

</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
import controller from '../scripts/controller/controller.js';

export default {
	props: {
		radio: {
			type: Boolean,
			default: false
		},

		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value',
		'select-all',
		'map-filter-changed'
	],

	data() {
		return {
			localValue: null,
			uniqueId: uniqueId('field-'),
			selectAll: null,
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		// handleInput() {
		// 	this.$emit('update:model-value', this.localValue);
		// },

		openSelect() {
			controller.openModal({
				className: 'modal--select-multiple',
				icon: this.field.icon,
				component: {
					name: 'v-modal-select-multiple',
					props: {
						dataSource: this.field,
						modelValue: this.localValue || [],
						modelSelectAll: this.selectAll || false,
					},
					listeners: {
						'change-select': async (data) => {
							this.localValue = data;
						},

						'change-select-all': async (data) => {
							this.selectAll = data;
						},

						'update:model-value': async (data) => {
							this.$emit('update:model-value', data);
						},

						'map-filter-changed': async (data) => {
							this.$emit('map-filter-changed', data);
						}
					}
				}
			});
		},

	},

	computed: {
		computedText() {
			let resultArr = [];
			for (let i = 0; i < this.localValue.length; i++) {
				for (let n = 0; n < this.field.options.length; n++) {
					if (this.field.options[n].value && this.field.options[n].value === this.localValue[i]) {
						resultArr.push(this.field.options[n].text);
					}
				}
			}
			return resultArr.join(', ');
		},
	}
};
</script>